module.exports = __webpack_public_path__ + "media/images/mr-1c2a7654ebf7ea915d84dc9552aab652.png";